import {initializeApp} from 'firebase/app'
import credentials from './credentials'

export const firebaseApp = initializeApp(credentials.config);